import { render, staticRenderFns } from "./ResultsRow.vue?vue&type=template&id=6d240298&scoped=true"
import script from "./ResultsRow.vue?vue&type=script&lang=ts"
export * from "./ResultsRow.vue?vue&type=script&lang=ts"
import style0 from "./ResultsRow.vue?vue&type=style&index=0&id=6d240298&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d240298",
  null
  
)

export default component.exports